import { ViewRegistration } from "aes-common";
import { Utils } from "../../services/Utils";

export class MetadataNode {
    static view = new ViewRegistration("Lookup Tables", "", "feed", [], function(){
        return !Utils.isAdminUser();
    });
}